export var LeaveRequestDTO =
{
    'leaveFrom': null,
    'leaveTo': null,
    'reason': null
}